import './_Notifications.scss';
import { Button, Tabs, List } from '@arkas/coreui';
import { InjectedIntlProps, injectIntl, FormattedMessage } from 'react-intl';
import commonResources from '@/common/resources/common';
import { NotificationDto } from '@emutabakat-types/mutabakat';
import React from 'react';
import Task from './Task/Task';

const TabPane = Tabs.TabPane;

interface NotificationsContentProps extends InjectedIntlProps {
  notifications: NotificationDto[];
  handleClearTasks: () => void;
}

/**
 * NotificationsContent Component
 */
class NotificationsContent extends React.Component<NotificationsContentProps> {
  handleClearTasks = () => {
    const { handleClearTasks } = this.props;
    handleClearTasks();
  };

  renderTaskItem = (item: NotificationDto) => {
    return (
      <List.Item style={{ margin: 10 }}>
        <Task item={item} />
      </List.Item>
    );
  };

  render() {
    const { notifications, intl } = this.props;
    return (
      <div className="notifications-content">
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={`${intl.formatMessage(commonResources.bildirimler)} (${
              notifications ? notifications.length : 0
            })`}
            key="1"
          >
            <List
              itemLayout="horizontal"
              dataSource={notifications}
              footer={
                <div style={{ padding: '0 12px', textAlign: 'center' }}>
                  <Button
                    icon="close"
                    type="primary"
                    shape="round"
                    onClick={this.handleClearTasks}
                    block={true}
                    hidden={notifications && notifications.length === 0}
                    style={{ color: 'white' }}
                  >
                    <FormattedMessage id={commonResources.temizle.id} />
                  </Button>
                </div>
              }
              renderItem={this.renderTaskItem}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default injectIntl(NotificationsContent);
